export default "__VITE_ASSET__D2N$EuEW__"